module.exports = __webpack_public_path__ + "static/media/ortogram.21cf5502.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ortogram.svg
// module id = 608
// module chunks = 0